/**
 * @项目名称: work
 * @功能名称: 上报核心库
 * @文件名称: utils
 * @Date: 2019/11/22
 * @Author: liux
 * @Copyright（C）2019 「小赢科技」 Inc.   All rights reserved.
 * 注意：本内容仅限于「小赢科技」内部传阅，禁止外泄以及用于其他的商业目的。
 */

 import utils from './utils'
 import cookie from '../helper/cookie'
 import { realType } from '../helper/utils'
 import xyJsBridge from '../xyJsBridge/xyJsBridge'
 import getBrowserInfo from '../helper/getBrowserInfo'
 import replaceDomain from '../xyHelper/replaceDomain'
 const browserInfo = getBrowserInfo()
 
 class Report extends utils {
   constructor (opt) {
     super()
     this.R = Object.assign({
       remoteUrl: replaceDomain('https://track.xiaoying.com/report'),
       projectId: (process.env.VUE_APP_MODE === 'prod' || !process.env.VUE_APP_MODE) ? 'cardloan_h5' : 'test',
       projectType: 'h5',
     }, opt)
     this.initData = {
       commonData: {
         projectId: this.R.projectId || '', // 项目ID,由业务方指定
         projectType: this.R.projectType || 'h5', // 项目类型，app，h5等
         cookieid: this.getCookieId(), // 随机生成的id，存储在浏览器的cookie中，用户每次打开页面都保持不变
         visitId: this.getVisitId(), // 用户打开页面时随机生成，用户在同一个会话中，该id保持不变，新的会话则生成一个新的visit_id
         userId: '', // 用户id，若用户产生行为时在登录状态，则上报
         openId: '', // 微信的open_id，同一用户同一应用唯一
         unionId: '', // 微信的union_id，同一用户不同应用唯一
         eventTime: 0, // 行为时间，用户产生对应行为的时间，为13位的时间戳
         eventName: '', // 行为名称，由需求方定义，若事件为page，改字段为非必传，若事件为action，则字段为必传
         url: '', // page时上传，页面的url
         referer: '', // page时上传，访问前页面的url
         pageId: '', // page时上传，非必传，用户每打开一个页面，都随机生成一个不同的id
         refererId: '', // page时上传，非必传，访前页面的page_id
         channelId: '', // 渠道id，若页面在外部投放，此处上报对应渠道的id，从url中的参数获取
         extendUser: '', // 扩展信息，一个json串，用于标识用户的拓展信息
         extendEvent: '', // 扩展信息，一个json串，用于标识对象的拓展信息
         custom: '', // 备注信息，可以是一个json串，也可以是一个值
         version: '1.0.0', // 数据格式版本号
         apiVersion: '1.0.0', // 当前接入的api的版本
         reportId: '', // 上报ID
       },
       elemData: {
         eventSource: 'action', // 行为大类，固定为page（页面行为）、action（按钮行为）
         eventType: 'action_click', // 行为小类，若大类为action，则小类为action_click
         actionType: 'element', // action行为类型，用于区分以上的三种类型,固定为list、element、position
         path: '', // 对应的xpath信息
         index: 0, // 按钮位置，主要用于列表型的数据上报
         actionId: '', // 用户点击按钮时生成的随机码
       },
       pageData: {
         eventSource: 'page', // 行为大类，固定为page（页面行为）、action（按钮行为）
         eventType: '', // 行为小类，若大类为page，则小类为page_hide和page_show
         timeOnPage: '', // 页面停留时长，仅仅在page_hide的时候上传
       },
     }
     this.pageInfo = {
       eventTime: 0,
       pageId: '',
       refererId: '',
       eventName: null,
       extendEvent: {}
     }
   }
   report (log, cb) {
     if(!log || !log.eventName) {
       return false
     }
     this.extend(log, { extendEvent: this.pageInfo.extendEvent })
     if(typeof cb !== 'function'){
       cb = function () {}
     }
     if(browserInfo.isBjAPP){
       return this.reportApp(log, cb)
     }else {
       return this.triggerUpload(this.formatLogData(log), cb)
     }
   }
   reportApp(log, cb){
     var eventTypeMap = {
       'page_hide':2,
       'page_show':1,
       'action_click':3
     }
     var params = {
       callback: log.callback || log.callBack,
       eventType: eventTypeMap[log.eventType]||3,  // 类型 1 页面显示 2 页面隐藏 3 按钮点击
       eventName: log.eventName,  // 事件名称
       reportUrl: log.url||log.reportUrl,  // 页面的Url
       actionType: log.actionType, // 按钮类型 （list/element/position）
       extendEvent: Object.assign({source: log.channelId},log.extendEvent),  //map对象 用于添加扩展字段，如果没有可以传{} extendEvent中的所有值都是string
     }
     if(params&&realType(params.extendEvent)==="object"){
       for (let key in params.extendEvent){
         // 客户端数据上报sdk要求extendEvent 中的值为String类型
         if(!params.extendEvent[key]&&params.extendEvent[key]!==0){
           params.extendEvent[key] = ''
         }else {
           params.extendEvent[key] = params.extendEvent[key]+'';
         }
       }
     }
     return xyJsBridge('jsbridge://www.xiaoying.com/app/operation/behaviorReport', params, cb)
   }
   triggerUpload (data, cb) {
     for (const key in data) {
       if (['',null,undefined].includes(data[key])) {
         delete data[key]
       }
     }
     if (this.R.remoteUrl) {
       const img = new Image()
       img.src = `${this.R.remoteUrl}?image=1&data=` + encodeURIComponent(JSON.stringify(data))
       img.addEventListener('error',cb)
     }
   }
 
   formatLogData (log) {
     for (const key in log) {
       if (!(log[key] && typeof log[key] === 'object')) {
         log[key] = log[key] + ''
       }
     }
     const data = {
       version: log.version || '',
       apiVersion: log.apiVersion || log.api_version || '',
       commons: {
         project: {
           projectId: log.projectId || log.project_id || '',
           projectType: log.projectType || log.project_type || '',
           userId: log.userId || log.user_id || '',
           openId: log.openId || log.open_id || '',
           unionId: log.unionId || log.union_id || '',
         },
         app: {},
         web: {
           cookieid: log.cookieId || log.cookieid || '',
         },
       },
       events: [
         {
           userId: log.userId || log.user_id || '',
           visitId: log.visitId || log.visit_id || '',
           eventSource: log.eventSource || log.event_source || '',
           eventType: log.eventType || log.event_type || '',
           eventTime: log.eventTime || log.event_time || '',
           eventName: log.eventName || log.event_name || '',
           url: log.url || '',
           referer: log.referer || '',
           pageId: log.pageId || log.page_id || '',
           refererId: log.refererId || log.referer_id || '',
           channelId: log.channelId || log.channel_id || '',
           extendUser: log.extendUser || log.extend_user || {},
           extendEvent: log.extendEvent || log.extend_event || {},
           custom: log.custom || {},
           reportId: log.reportId || log.report_id || '',
           actionType: log.actionType || log.action_type || '',
           actionId: log.actionId || log.action_id || '',
           path: log.path || '',
           index: log.index || '',
           timeOnPage: log.timeOnPage || log.time_on_page || '',
         },
       ],
     }
     return data
   }
 
   getCommonData () {
     /**
      projectId: projectId, // 项目ID,由业务方指定
      projectType: projectType, // 项目类型，app，h5等
      cookieid: '', // 随机生成的id，存储在浏览器的cookie中，用户每次打开页面都保持不变
      userId: '', // 用户id，若用户产生行为时在登录状态，则上报
      openId: '', // 微信的open_id，同一用户同一应用唯一
      unionId: '', // 微信的union_id，同一用户不同应用唯一
      visitId: visitId, // 用户打开页面时随机生成，用户在同一个会话中，该id保持不变，新的会话则生成一个新的visit_id
      eventTime: 0, // 行为时间，用户产生对应行为的时间，为13位的时间戳
      eventName: '', // 行为名称，由需求方定义，若事件为page，改字段为非必传，若事件为action，则字段为必传
      url: '', // page时上传，页面的url
      referer: '', // page时上传，访问前页面的url
      pageId: '', // page时上传，非必传，用户每打开一个页面，都随机生成一个不同的id
      refererId: '', // page时上传，非必传，访前页面的page_id
      channelId: '', // 渠道id，若页面在外部投放，此处上报对应渠道的id，从url中的参数获取
      extendUser: '', // 扩展信息，一个json串，用于标识用户的拓展信息
      extendEvent: '', // 扩展信息，一个json串，用于标识对象的拓展信息
      custom: '', // 备注信息，可以是一个json串，也可以是一个值
      */
     return {
       userId: cookie.get('uid') || cookie.get('userId') || cookie.get('user_id') || '',
       openId: cookie.get('openId') || cookie.get('open_id') || '',
       unionId: cookie.get('unionId') || cookie.get('union_id') || '',
       eventTime: this.getCurrentTime(),
       url: location.origin+location.pathname,
       referer: document.referrer || (window.opener && window.opener.location && window.opener.location.href) || '',
       channelId: this.query('channelId') || this.query('channel_id') || this.query('source')
     }
   }
 
   reportPage (data = {}) {
     /**
      *  eventType: '', // 行为小类，若大类为page，则小类为page_hide和page_show，若大类为action，则小类为action_click
      timeOnPage: '', // 页面停留时长，仅仅在page_hide的时候上传
      */
     const pageData = this.extend({}, this.initData.commonData, this.getCommonData(), this.initData.pageData, data)
     this.report(pageData)
   }
 
   pageShow (data = {},cache) {
     if(data.disable){
       return
     }
     if ((data.eventName === this.pageInfo.eventName && this.pageInfo.eventName) || !data.eventName) {
       return // 重复的pv show 直接return
     }
     this.cache(data, cache)
     let time = this.getCurrentTime()
     let pageId = data.pageId || this.createUniqueString()
     let d = {
       eventTime: time,
       refererId: this.pageInfo.refererId,
       pageId: pageId,
       eventType: 'page_show'
     }
     this.reportPage(this.extend(d, data))
     this.pageInfo.eventTime = time
     this.pageInfo.pageId = pageId
     this.pageInfo.eventName = data.eventName
     this.pageInfo.extendEvent = data.extendEvent || {}
   }
 
   pageHide (data = {}) {
     if(this.pageInfo.eventName === null)return
     let time = this.getCurrentTime()
     let d = {
       eventTime: time,
       timeOnPage: time - this.pageInfo.eventTime,
       refererId: this.pageInfo.refererId,
       pageId: this.pageInfo.pageId,
       eventType: 'page_hide',
       eventName: data.eventName || this.pageInfo.eventName
     }
     this.reportPage(this.extend(d, data))
     this.pageInfo.refererId = this.pageInfo.pageId
     this.pageInfo.eventName = ''
     this.pageInfo.extendEvent = {}
   }
 
   cache(data, cache){
     if(!cache)return;
     /**
      channelId:  渠道号,
      userId: ,  用户id，若用户产生行为时在登录状态，则上报
      openId: ,  微信的open_id，同一用户同一应用唯一
      unionId: ,  微信的union_id，同一用户不同应用唯一
      extendUser: ,  扩展信息，一个json串，用于标识用户的拓展信息
      extendEvent: ,  扩展信息，一个json串，用于标识对象的拓展信息
      custom:  备注信息，可以是一个json串，也可以是一个值
      *
      */
     var cacheMaps = ['channelId','userId','openId','unionId','extendUser','extendEvent','custom']
     var keys = Object.keys(data)
     var result = {}
     cacheMaps.forEach(item=>{
       if(keys.includes(item)){
         result[item] = data[item]
       }
     })
     this.extend(this.initData.commonData, result)
   }
 
   /**
    * @param data
    * @param cache
    * @param noExtendEventName Boolean 是否继承路由eventName
    */
   reportElement (data = {}, cache, noExtendEventName = false) {
     if (typeof data.eventName !== 'string') {
       return console.warn('action_click eventName is not string')
     }
     /**
      *  eventType: '', // 行为小类，若大类为page，则小类为page_hide和page_show，若大类为action，则小类为action_click
      *  actionType: '', // action行为类型，用于区分以上的三种类型,固定为list、element、position
      *  path: '', // 对应的xpath信息
      *  index: 0, // 按钮位置，主要用于列表型的数据上报
      *  actionId: // 随机码
      */
     if (this.pageInfo.eventName && data.eventName && !noExtendEventName) {
       data.eventName = this.pageInfo.eventName + '_' + data.eventName
     }
     this.cache(data, cache)
     var elementData = this.extend(
       {},
       this.initData.commonData,
       this.getCommonData(),
       this.initData.elemData,
       {
         path: this.readXPath(data.element) || '',
         actionId: this.createUniqueString(),
       },
       data
     )
     this.report(this.extend(this.getCommonData(), elementData))
   }
 
   /**
    * @param eventName
    * @param data
    * @param cache
    * @param noExtendEventName Boolean 是否继承路由eventName
    */
   xreport (eventName, data={}, cache, noExtendEventName) {
     this.reportElement({
       eventName: eventName,
       ...data
     }, cache, noExtendEventName)
   }
 
 }
 
 export default Report
 